import { render } from "./range-sliders.vue?vue&type=template&id=642e644f"
import script from "./range-sliders.vue?vue&type=script&lang=js"
export * from "./range-sliders.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__